var locks = new Set();
/**
 * Hides the scroll bar by setting `overflow: hidden` on the `body` element.
 */

function scrollLock(element) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      abortSignal = _ref.abortSignal;

  locks.add(element);
  var controller = new AbortController();
  var signal = abortSignal || controller.signal;
  var scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  var prevPaddingRight;
  var prevOverflowSetting;

  if (prevPaddingRight === undefined && scrollBarWidth > 0) {
    var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
    prevPaddingRight = document.body.style.paddingRight;
    document.body.style.paddingRight = "".concat(computedBodyPaddingRight + scrollBarWidth, "px");
  }

  if (prevOverflowSetting === undefined) {
    prevOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  signal.addEventListener('abort', function () {
    locks.delete(element);

    if (locks.size !== 0) {
      return;
    } // Remove the scroll lock styles if there are no locks.


    if (prevPaddingRight !== undefined) {
      document.body.style.paddingRight = prevPaddingRight;
      prevPaddingRight = undefined;
    }

    if (prevOverflowSetting !== undefined) {
      document.body.style.overflow = prevOverflowSetting;
      prevOverflowSetting = undefined;
    }
  });
  return controller;
}

export { scrollLock as default };